import {iconMap} from '@/icons/icon-map';

import type {IconName} from '@/icons/icon-map';
import type {SVGProps} from 'react';

export type {IconName};

export type IconProps = SVGProps<SVGSVGElement> & {
  name: IconName;
};

export function Icon({name, width = '100%', height = '100%', ...props}: IconProps) {
  const IconComponent = iconMap[name];
  return <IconComponent data-slot="icon" width={width} height={height} {...props} />;
}
